import {Card, Col, Row} from "antd";
import {useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";
import {ApplicationUserRole} from "../../api";
import useCurrentUserRoles from "../../hooks/useCurrentUserRoles";
import React from 'react';
import styles from "./mainPage.module.scss";

interface MenuCard {
    title: string,
    route: string;
}

const DividerWithText = ({ text }: { text: string }) => (
    <div className={styles.dividerContainer}>
        <div className={styles.dividerLeft}/>
        <span className={styles.dividerText}>{text}</span>
        <div className={styles.dividerRight}/>
    </div>
);

export default function MainPage() {
    const navigate = useNavigate();
    const roles = useCurrentUserRoles();

    const card = (title: string, route: string) => (
        <Col xs={24} md={24} lg={6} key={route}>
            <Card onClick={() => navigate(route)} className="menu-card" hoverable>
                <div style={{textAlign: "center"}}>{title}</div>
            </Card>
        </Col>
    );

    const renderCards = (cards: MenuCard[]) => cards.map(({title, route}) => card(title, route));

    const menuManagerCards = [
        {title: "Kategorie menu", route: RoutingPaths.menuCategoryTable.route},
        {title: "Menu PDF", route: RoutingPaths.menu.route}
    ].filter(card => roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.MenuManager));

    const newsManagerCards = [
        {title: "Aktualności", route: RoutingPaths.news.route}
    ].filter(card => roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.NewsManager));

    const beerManagerCards = [
        {title: "Rodzaje piw", route: RoutingPaths.beerTable.route}
    ].filter(card => roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.BeerManager));

    const delibeefCards = [
        {title: "Kategorie produktów", route: RoutingPaths.parentCategoryTable.route},
        {title: "Zamówienia", route: RoutingPaths.orders.route},
        {title: "Koszyki", route: RoutingPaths.baskets.route},
        {title: "Kody rabatowe", route: RoutingPaths.discountCodeTable.route}
    ].filter(card => roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.ProductManager) || roles.includes(ApplicationUserRole.OrderManager));

    const adminCards = [
        {title: "Użytkownicy", route: RoutingPaths.userList.route},
        {title: "Publikacja", route: RoutingPaths.deploy.route}
    ].filter(card => roles.includes(ApplicationUserRole.Admin));

    return <>
        <h2>Strona główna</h2>
        {delibeefCards.length > 0 && (
            <DividerWithText text="Beefteka & BrowarKoło"/>
        )}
        <Row gutter={[16, 16]} className="main-page-row">
            {renderCards(menuManagerCards)}
            {renderCards(newsManagerCards)}
            {renderCards(beerManagerCards)}
        </Row>
        {delibeefCards.length > 0 && (
            <DividerWithText text="Delibeef"/>
        )}
        <Row gutter={[16, 16]} className="main-page-row">
            {renderCards(delibeefCards)}
        </Row>
        {adminCards.length > 0 && (
            <DividerWithText text="Admin"/>
        )}
        <Row gutter={[16, 16]} className="main-page-row">
            {renderCards(adminCards)}
        </Row>

    </>
}
